import logo from '../logo.svg';
import '../styles/App.scss';
import Header from './Header';
import FrontPageContent from './FrontPageContent';
import Projects from './Projects';
import Stack from './Stack';
import WhatIDo from './WhatIDo';
import LanguageSelector from './LanguageSelector';
import Blog from './Blog';
import WhoAmI from './WhoAmI';
import Footer from './Footer'

function App() {
  return (
    <div className="App">
     <LanguageSelector/>
     <Header/>
     <FrontPageContent/>
     <WhatIDo/>
     <Stack/>
     <Blog/>
     <Projects/>
     <WhoAmI/>
     <Footer/>
    </div>
  );
}

export default App;
